<div class="container m-t-10 m-b-8" id="privacy-policy">
    <div class="header d-flex align-items-center justify-content-between">
        <div class="header-text">
            <h4>{{title}}</h4>
        </div>
        <button class="close-icon d-flex align-items-center justify-content-center" type="button"
            (click)="closeDialog()" aria-label="Close">
            <span aria-hidden="true" style="font-size: 32px; line-height: 1;">&times;</span>
        </button>
    </div>

    <!-- Scrollable Popup Content -->
    <div class="scrollbar scrollable-content custom-scroll">

        <ag-grid-angular class="ag-theme-material" style="width: 100%; height: 300px;" [rowData]="mappingdata"
            [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [domLayout]="'autoHeight'"
            *ngIf="mappingdata && mappingdata.length > 0; else noData">
        </ag-grid-angular>
        <ng-template #noData>
            <div class="text-center m-t-20 m-b-20">
                No Data Found
            </div>
        </ng-template>
    </div>
</div>